import { cn } from '@/lib/utils';

// Domino Solaire mark: a sun-yellow domino tile whose base is cut by horizontal 70s sunset stripes.
// Stripes take the `ground` color so they read as cut into the surface behind; with `tile`, the mark sits on its own red square.
export const DominoLogo = ({ className, ground = '#D8361E', tile = false }: { className?: string; ground?: string; tile?: boolean }) => {
  const cut = tile ? '#FF4C33' : ground;
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" className={cn('shrink-0', className)}>
      {tile && <rect width="64" height="64" rx="14" fill={cut} />}
      <rect x="17" y="6" width="30" height="52" rx="6" fill="#FFD84D" />
      <rect x="17" y="37" width="30" height="1.75" fill={cut} />
      <rect x="17" y="42" width="30" height="2.75" fill={cut} />
      <rect x="17" y="48" width="30" height="3.75" fill={cut} />
    </svg>
  );
};
